import { NURSING_MANAGEMENT_ADMIN } from "../apiConstant";
import BaseApi from "api/baseApi";

class NursingApi extends BaseApi {
  getList(body: {
    per: number;
    page: number;
    // fullname: string | null,
    // status: string | null,
    // sortKey: string | null,
    // order: string | null,
  }) {
    return this.get(NURSING_MANAGEMENT_ADMIN, body);
  }
}

export default NursingApi;
